// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Injectable } from '@movecloser/front-core';
import { AbstractAsyncRelatedService, AbstractRelatedService } from './abstract';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
let AsyncRelatedService = class AsyncRelatedService extends AbstractAsyncRelatedService {
};
AsyncRelatedService = __decorate([
    Injectable()
], AsyncRelatedService);
export { AsyncRelatedService };
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
let RelatedService = class RelatedService extends AbstractRelatedService {
};
RelatedService = __decorate([
    Injectable()
], RelatedService);
export { RelatedService };
